module.exports = __webpack_public_path__ + "img/carte-bleue.a557ec93.png";